import React from "react";
import { Tabs } from 'antd';
import StorageTankList from "../components/storage-tank/StorageTankList";
import StorageTankLotHistoryList from "../components/storage-tank/StorageTankLotHistoryList";
import PondLatexList from "../components/pond-latex/PondLatexList";

export default function StorageTankView() {

  const items = [
    {
      key: 'current',
      label: 'แทงก์น้ำยางข้น',
      children: <StorageTankList/>,
    },
    {
      key: 'history',
      label: 'ประวัติล็อตน้ำยางข้น',
      children: <StorageTankLotHistoryList/>
    },
    {
      key: 'pond',
      label: 'ปิดบ่อพักน้ำยางสด',
      children: <PondLatexList role='tank'/>
    },
  ];

  return (
    <div>
      <Tabs 
        defaultActiveKey="current" 
        destroyInactiveTabPane
        items={items} 
        style={{ marginTop : 16}}
      />
    </div>
  )
}